import { ShimmerBlock } from './Shimmer'

export function ListingSkeleton({ count = 9 }: { count?: number }) {
  return (
    <div className="listing-page">
      <ShimmerBlock width={220} height={34} style={{ marginBottom: 12 }} />
      <ShimmerBlock width={320} height={16} style={{ marginBottom: 30 }} />
      <div className="entity-grid">
        {Array.from({ length: count }).map((_, i) => (
          <div className="entity-card" key={i}>
            <ShimmerBlock className="entity-cover" width="100%" height={150} radius={0} />
            <div className="entity-body">
              <ShimmerBlock width="70%" height={20} style={{ marginBottom: 8 }} />
              <ShimmerBlock width="45%" height={13} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
